<template>
  <div class="container-binds-select">
    <p class="placeholder-selector" v-if="placeholder">{{ placeholder }}</p>
    <div class="selector" @click="toggleDropdown">
      <i v-if="icon" class="material-icons icon-selector">{{ icon }}</i>
      <span :class="`selected-option select-${id}`" v-show="!showDropdown">{{ titleSelected }}</span>
      <input type="text" :class="`search-option search-option-${id}`" v-show="showDropdown" v-model="search">
      <div v-if="showDropdown" class="dropdown-selector" @click.stop>
        <p class="option-selector"
          :class="{'expired': option.isExpired}"
          v-for="(option, idx) in filteredOptions"
          :key="option._id"
          @click="selectOption(option)">
          <span v-if="showIndex">{{ idx + 1 }} - {{ option[titleItem] }}</span>
          <span v-else>{{ option[titleItem] }}</span>
          <i v-if="option.isExpired" class="material-icons expired-icon-select">timer_off</i>
        </p>
      </div>
      <div class="icon-selector">
        <i class="material-icons icon-expand" v-if="showDropdown">expand_less</i>
        <i class="material-icons icon-expand" v-else>expand_more</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: ['options', 'icon', 'titleItem', 'id', 'placeholder', 'reduce', 'value', 'showIndex'],
  data () {
    return {
      showDropdown: false,
      search: '',
      selectedOption: {}
    }
  },
  mounted () {
    document.addEventListener('click', (event) => {
      if (!this.$el.contains(event.target)) { this.showDropdown = false }
    })
  },
  computed: {
    filteredOptions () {
      if (this.search === '') {
        return this.options
      }

      const regex = new RegExp(this.search, 'gi')
      return this.options.filter((item) => {
        for (let key in item) {
          if (regex.test(item[key])) { return true }
        }
        return false
      })
    },
    titleSelected () {
      let title = 'Selecionar'
      if (typeof this.selectedOption[this.titleItem] === 'string') { title = this.selectedOption[this.titleItem] }
      if (typeof this.selectedOption === 'string') { title = this.selectedOption }
      return title
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.selectedOption = this.reduce ? this.options.find((e) => e[this.reduce] === newVal) : newVal
        }
      }
    }
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
      const selectedOptionElement = document.querySelector(`.select-${this.id}`)
      const searchInput = document.querySelector(`.search-option-${this.id}`)
      if (this.showDropdown) {
        selectedOptionElement.style.display = 'none'
        setTimeout(() => searchInput.focus())
      } else {
        selectedOptionElement.style.display = 'block'
      }
      this.search = ''
    },
    selectOption (option) {
      this.selectedOption = option
      this.showDropdown = false
      if (this.reduce) {
        this.$emit('input', this.selectedOption[this.reduce])
        this.$emit('model', this.selectedOption[this.reduce])
      } else {
        this.$emit('model', this.selectedOption)
        this.$emit('input', this.selectedOption)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 62.5%;
}

.expired {
  background: #efefef;
  border-top: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .expired-icon-select {
    font-size: 0.9vw;
  }
}

.container-binds-select {
  background: #ffffff;
  width: 14vw;
  height: 2.1vw;
  border-radius: 0.3rem;
  padding: 3px 0;
  border: 1px solid #cacaca;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  box-shadow: 0 0 7px 0 rgba(48, 48, 48, 0.16), 0 5px 4px 0 rgba(0, 0, 0, 0.01);
  .placeholder-selector {
    font-size: 0.5vw;
    padding-left: 0.3rem;
    font-weight: bold;
    text-transform: uppercase;
    color: #454548;
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
  }
  .selector {
    position: relative;
    height: 1.2rem;
    padding: 0.2rem 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    color: #454548;
    .icon-selector {
      font-size: 1.3rem;
      color: #808080;
      margin-right: 0.2rem;
    }
    .search-option {
      width: 100%;
      height: 100%;
      outline: none;
      border: none;
      padding-left: 0.5rem;
      font-size: 0.75vw;
      color: #808080;
    }
    .selected-option {
      max-width: 13.5rem;
      font-size: 0.75vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #808080;
      text-shadow: 0px 0px 2px #80808020;
      line-height: 1vw;
      font-family: "Open Sans", Helvetica, Arial, sans-serif;
    }
    .dropdown-selector {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 999;
      width: 100%;
      max-height: 15rem;
      overflow-y: auto;
      background-color: #ffffff;
      border: 0.1rem solid #cacaca;
      border-radius: 0 0 0.3rem 0.3rem;
      .option-selector {
        padding: 0.5rem;
        font-size: 0.75vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          font-size: 0.75vw;
          cursor: pointer;
          font-family: "Open Sans", Helvetica, Arial, sans-serif;
        }
      }
      .option-selector:hover {
        background: #1e90ff;
        color: #ffffff;
      }
    }
  }
  .icon-selector {
    .icon-expand {
      font-size: 1.5rem;
      color: var(--accent-color);
    }
  }
}

</style>
